import React, { useEffect, useState } from "react";
import { Col, Row, Tabs, Tab, NavDropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  setCurrentPageTitle,
  setCurrentRoute,
} from "../app/store/layoutUI";

// Components
import AgencyInvoiceBased from "../app/components/Reports/Monthly/Financial/AgencyInvoiceBased";
import AgencyCandidateBased from "../app/components/Reports/Monthly/Financial/AgencyCandidateBased";
import SubcontractorCandidates from "../app/components/Reports/Monthly/Payment/SubcontractorCandidates";
import RecruiterCandidates from "../app/components/Reports/Monthly/Payment/RecruiterCandidates";
import AgencyInvoiceCandidate from "../app/components/Reports/Monthly/AgencyInvoiceCandidate";
import GrossProfitCandidates from "../app/components/Reports/Monthly/GrossProfitCandidates";
import BurnHourCandidate from "../app/components/Reports/Monthly/BurnHourCandidate";
import AgencyInvBased from "../app/components/Reports/Quarterly/Financial/AgencyInvBased";
import AgencyCanBased from "../app/components/Reports/Quarterly/Financial/AgencyCanBased";
import AgencyInvoicePayment from "../app/components/Reports/Other/AgencyInvoicePayment";
import SubcontractorComp from "../app/components/Reports/Compliance/SubcontractorComp";
import RecruiterComp from "../app/components/Reports/Compliance/RecruiterComp";
import W2CandidateComp from "../app/components/Reports/Compliance/W2CandidateComp";
import Ten99CandidateComp from "../app/components/Reports/Compliance/Ten99CandidateComp";
import BurnHrCandidate from "../app/components/Reports/Quarterly/BurnHrCandidate";
import AchInformation from "../app/components/Reports/Other/AchInformation";
import InsuranceInformation from "../app/components/Reports/Other/InsuranceInformation";
import CandidateVisaStatus from "../app/components/Reports/Other/CandidateVisaStatus";
import SubcontractorRecruiter from "../app/components/Reports/Monthly/Ach/SubcontractorRecruiter";

const CustomReport = () => {
  const dispatch = useDispatch();
  const { type } = useParams();

  const [selectedReport, setSelectedReport] = useState("Select Report");
  const [selectedCompliance, setSelectedCompliance] = useState("Select the Entity to send the reports to");
  const [activeKey, setActiveKey] = useState("internal");

  // ------------------------------
  // Report / Compliance definitions
  // ------------------------------
  const reportOptions = [
    { name: "ACH Information Reports", component: <AchInformation /> },
    { name: "Insurance Information Reports", component: <InsuranceInformation /> },
    { name: "Candidate Visa Status Reports", component: <CandidateVisaStatus />},
    // { name: "ACH - Subcontractors", component: <RecruiterSubcontractor type="Sub-Contractors" /> },
    // { name: "ACH - Recruiter", component: <RecruiterSubcontractor type="Recruiter" /> },
    { name: "Monthly ACH - Payments", component: <SubcontractorRecruiter /> },
    //{ name: "Monthly ACH – Payments to Recruiters", component: <Recruiter /> },
    { name: "Financial Report - (Accrual Basis - Invoice Based)", component: <AgencyInvoiceBased /> },
    //{ name: "Financial Report - Quarterly (Accrual Basis - Invoice Based)", component: <AgencyInvBased /> },
    { name: "Financial Report - (Accrual Basis - Candidate Based)", component: <AgencyCandidateBased /> },
    //{ name: "Financial Report - Quarterly (Accrual Basis - Candidate Based)", component: <AgencyCanBased /> },

    { name: "Monthly Payments (Per Candidate Basis)", component: <SubcontractorCandidates /> },
    //{ name: "Monthly Payments to Recruiter (Per Candidate Basis)", component: <RecruiterCandidates /> },

    { name: "Monthly Invoices to Client (Per Candidate-Basis)", component: <AgencyInvoiceCandidate /> },
    { name: "Monthly Gross Profit Reports - Per Candidate Basis", component: <GrossProfitCandidates /> },
    { name: "Burn Reports - Per Candidate Basis", component: <BurnHourCandidate /> },
    //{ name: "Quarterly Burn Reports – Per Candidate Basis", component: <BurnHrCandidate /> },
  ];

  const complianceOptions = [
    { name: "Subcontractors", component: <SubcontractorComp /> },
    { name: "Recruiters", component: <RecruiterComp /> },
    { name: "W2 Candidates", component: <W2CandidateComp /> },
    { name: "1099 Candidates", component: <Ten99CandidateComp /> },
  ];

  useEffect(() => {
    const pageTitle = type === "compliance" ? "Compliance Reports/Docs" : "Business Reports";
    dispatch(setCurrentPageTitle(pageTitle));
    dispatch(setCurrentRoute([{ name: "Analytics", url: "" }]));
  }, [type, dispatch]);

  const renderDropdown = (options, selected, onSelect) => (
    <NavDropdown title={selected} id="nav-dropdown" className="btn btn-secondary bg-white" style={{zIndex:101}}>
      {options.map(({ name }) => (
        <NavDropdown.Item key={name} onClick={() => onSelect(name)}>
          {name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );

  const renderSelectedContent = (options, selected) => {
    const match = options.find((item) => item.name === selected);
    return match ? match.component : null;
  };

  // ------------------------------
  // Render Business or Compliance Tabs
  // ------------------------------
  if (type === "compliance") {
    // ✅ COMPLIANCE VIEW
    return (
      <div className="col-md-12">
        <Tabs defaultActiveKey="compliance" id="compliance-tabs" className="bg-light border" variant="pills">
          <Tab eventKey="compliance" title="Compliance Statements" tabClassName="m-3">
            <Row>
              <Col sm={12}>
                <div className="p-3 border bg-lighter">
                  {renderDropdown(complianceOptions, selectedCompliance, setSelectedCompliance)}
                </div>
              </Col>
              <Col sm={12} className="mt-3">
                {renderSelectedContent(complianceOptions, selectedCompliance)}
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </div>
    );
  }

  // ✅ BUSINESS VIEW
  return (
    <div className="col-md-12">
      <Tabs
        id="business-tabs"
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
        className="bg-light border"
        variant="pills"
      >
        {/* Internal Tab */}
        <Tab eventKey="internal" title="Internal to IPCS" tabClassName="m-3">
          <Row>
            <Col sm={12}>
              <div className="p-3 border bg-lighter">
                {renderDropdown(reportOptions, selectedReport, setSelectedReport)}
              </div>
            </Col>
            <Col sm={12} className="mt-3">
              {renderSelectedContent(reportOptions, selectedReport)}
            </Col>
          </Row>
        </Tab>

        {/* Agencies Tab */}
        <Tab
          eventKey="agencies"
          title="Agencies - Monthly/Quarterly/Yearly"
          tabClassName="m-3"
        >
          <Row>
            <Col sm={12}>
              <div className="p-3 border bg-lighter">
                <div className="btn btn-secondary bg-white">
                  State - Invoice, Payments and Fees (Monthly/Quarterly/Yearly)
                </div>
              </div>
            </Col>
            <Col sm={12} className="mt-3">
              {/* ✅ Only render when agencies tab is active */}
              {activeKey === "agencies" && <AgencyInvoicePayment />}
            </Col>
          </Row>
        </Tab>
      </Tabs>
    </div>
  );
};

export default CustomReport;
